module.exports=[
  {
    "name": "Bankai",
    "description": "Web Compiler.",
    "url": "https://bankai.choo.io",
    "date": "2015-12-24"
  },
  {
    "name": "Choo",
    "description": "Browser Abstraction.",
    "url": "https://choo.io",
    "date": "2016-03-10"
  },
  {
    "name": "Saisho",
    "description": "What do we want?",
    "url": "https://saisho.yoshuawuyts.com",
    "date": "2018-01-19"
  },
  {
    "name": "Welcome",
    "description": "A new landing page.",
    "url": "https://welcome.choo.io",
    "date": "2018-02-03"
  },
  {
    "name": "Memex",
    "description": "What have I done?",
    "url": "https://yoshuawuyts.com",
    "date": "2018-02-03"
  },
  {
    "name": "Eleven",
    "description": "Drink me.",
    "url": "https://eleven.yoshuawuyts.com",
    "date": "2018-02-04"
  },
  {
    "name": "Dat.rs",
    "description": "Sync me.",
    "url": "https://datrs.yoshuawuyts.com",
    "date": "2018-03-01"
  }
]
